import React, { Component } from 'react';
import '../../App.css';
import TelevisionBreakpoint from "../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../components/responsive_utilities/phone_breakpoint";
import Dimensions from 'react-dimensions';
import ReactPlayer from 'react-player';
const sancoLogo = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sancoLogoWhite.png?alt=media&token=67607409-da15-41c6-8fa9-c9881c696085';

var firebase = require('firebase/app');
require('firebase/database');


class Runaway extends Component {
  
  constructor() {
    super();
    this.state = {
      currentVideo: '',
			vidList: [],
      vidPlaying: true,
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);  
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener("keyup", this.keyHandling);
		this.fetchVideosList();
		var fetchVids = setInterval(
			function() {
					this.fetchVideosList();
			}
			.bind(this),
			10800000
		);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("keyup", this.keyHandling);
  }
	
	componentWillReceiveProps(newProps) {
		this.setState({channelAPI: newProps.channelAPI, channelID: newProps.channelID});
		this.fetchVideosList();
	}
	
	fetchVideosList() {
		const API = 'AIzaSyDPOAO90Hmjyg73TusAFE4-OfbaDIkfkwU';
		const channelID = 'PLBE2HTUQ9kZs7qZtSD1RRxN9wTfoSgzzy';
		const results = 50;
		var vidList = [];
		
		var finalURL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${channelID}&maxResults=${results}&key=${API}`;
		
		fetch(finalURL)
      .then((response) => response.json())
      .then((resp) => { 
				resp.items.forEach((item) => {
					console.log('Item: ', item)
					vidList.unshift({
						url: 'https://youtu.be/' + item.snippet.resourceId.videoId,
						title: item.snippet.title,
						desc: item.snippet.description
					})
				})
				this.setState({
					vidList,
					currentVideo: vidList[0],
				})
      })
      .catch((error) => {
        console.error(error);
      });
	}
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    } else if(e.keyCode === 227) {
      this.previousVideo(this.state.currentVideo)
    } else if(e.keyCode === 228) {
      this.nextVideo(this.state.currentVideo)
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  
  nextVideo(currentVideo) {
    const videolist = this.state.vidList;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videolist[next]
    })
  }

  previousVideo(currentVideo) {
    const videolist = this.state.vidList;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var previous = index - 1;
    } else {
      var previous = 0;
    }
    this.setState({
      currentVideo: videolist[previous]
    })
  }
  
  render() {
		if(this.state.currentVideo.desc) {
			var currentVideoDesc = this.state.currentVideo.desc.slice(0, 50);
		}
		
    return (
      <div
        className='wrapper'
        width= {this.state.width}
        height= {this.state.height} >
			<TelevisionBreakpoint>
        <ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlay'>
            <div className='sancoLogo'>
              <img src={sancoLogo} height={90} width={200}/>
            </div>
            <div className='vidTitle'>
                {this.state.currentVideo.title}
            </div>
						<div className='vidDesc'>
                {currentVideoDesc}
            </div>
          </div> : null }
				</TelevisionBreakpoint>
				<DesktopBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayDesktop'>
            <div className='sancoLogoDesktop'>
              <img src={sancoLogo} height={45} width={100}/>
            </div>
            <div className='vidTitleDesktop'>
                {this.state.currentVideo.title}
            </div>
						<div className='vidDescDesktop'>
                {currentVideoDesc}
            </div>
          </div> : null }
				</DesktopBreakpoint>
				<TabletBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayDesktop'>
            <div className='sancoLogoDesktop'>
              <img src={sancoLogo} height={45} width={100}/>
            </div>
            <div className='vidTitleDesktop'>
                {this.state.currentVideo.title}
            </div>
						<div className='vidDescDesktop'>
                {currentVideoDesc}
            </div>
          </div> : null }
				</TabletBreakpoint>
				<PhoneBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width='100%'
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayPhone'>
            <div className='sancoLogo'>
              <img src={sancoLogo} height={30} width={60}/>
            </div>
            <div className='vidTitlePhone'>
                {this.state.currentVideo.title}
								<div className='vidDescPhone'>
									{currentVideoDesc}
							</div>
            </div>
          </div> : null }
				</PhoneBreakpoint>
      </div>
    );
  }
}

export default Runaway;


// WEBPACK FOOTER //
// ./src/pages/restaurants/Runaway.js